import React, { useContext, useEffect, useRef, useState } from 'react'
import Select from 'react-select';
import AppBreadCrumb from '../../common/AppBreadCrumb'

import { getUsers } from '../../../api/UsersAPI';
import { createUser, fetchUser, UpdateUser } from '../../../api/UsersAPI';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter, replaceHyphenwithSpace } from '../../../commonfunctions';
import { getRoles } from  '../../../api/milma_admin/RolesAPI';
import { AuthContext } from '../../AuthContext';

const UsersForm  = (props) => {

  const { formType, currentUserId } = props;
  const navigate = useNavigate();
  const formRef = useRef(null);
 

  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserError, setCurrentUserError] = useState(null);
  const [roles, setRoles] = useState([]);

  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToaster] = useState({});
  const [selectedRoles, setSelectedRoles] = useState(new Set());




  useEffect(() => {

    getRoles({ paginate: false }, function (response) {
      console.log("hello", response.roles);

      setRoles(response.roles);
      ;

    });



  }, []);




  const customStyles = {
    option: (provided, user) => ({
      ...provided,
      color: 'black', // Set label color to black
      backgroundColor: user.isFocused ? '#11a1fd' : 'white', // Blue on hover, white otherwise
      color: user.isFocused ? 'white' : 'black', //White text on blue, black otherwise
      padding: '15',
    }),
    control: (provided) => ({
      ...provided,
      borderColor: 'rgba(98,98,98, 0.4)', // Optional: customize the border
    }),
    singleValue: (provided, User) => ({
      ...provided,
      textAlign: 'left', // Align the selected value text to the left
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0.5rem 0.5rem',
    }),

  };


  const saveAddUserForm = (exitForm) => {

    console.log("new User is", currentUser);

    setCurrentUserError({});
     const rolesArray = [...selectedRoles];
    const saveUser = { ...currentUser, role_ids: rolesArray };

    createUser(saveUser, function (response) {
      console.log("in createUser", response);

      if ("user" in response) {


        // setSaveCompleted(prevUser => !prevUser); // Toggle the User
        if (exitForm) {

          navigate('/franchisee_user/users', {
            state: { message: 'User saved successfully!' }
          });
        }
        else {
          setShowToaster(true);
          setToaster({ type: 'success', heading: 'Success', message: 'User Added Successfully' });
          setCurrentUser(null);
          setSelectedRoles(new Set());
        }
      }
      else {
        // Use the generic error handling function
        console.log("error Response", response);

        handleApiError(response, setCurrentUserError);
      }


    });

  }

  const handleResetUserForm = () => {

    setCurrentUser(null);
    setCurrentUserError(null);
  }

  const getTitle = () => {

    console.log("formType", formType);

    if (formType == 'create') {
      return 'Create New User Wizard'
    }
    else {
      return 'Edit User Wizard'
    }
  }

  useEffect(() => {
    setCurrentUser(null);

    if (formType != null && formType != 'create' && currentUserId) {

      fetchUser(currentUserId, function (response) {
        console.log("in fetchUser", response);

        if ("user" in response) {
          // response.user.state.selectedoption = { label: response.user.state.name, value: response.user.state.id };
          // if(response.user.user)
          // {
          //   response.user.user.selectedoption = {label: response.user.user.name, value: response.user.user.id };

          // }
          // else
          // {
          //   //  response.user.user = null;
          // }
          setCurrentUser(response.user);
          setSelectedRoles(new Set(response.user?.role_ids));



        }



      });
    }

  }, [formType, currentUserId]);


  const saveEditUserForm = (exitForm) => {


    setCurrentUserError(null);
    const rolesArray = [...selectedRoles];
    const saveUser = { ...currentUser, role_ids: rolesArray };
    UpdateUser(currentUser, function (response) {
      console.log("in updateUser", response);

      if ("user" in response) {

        // setToaster({ type: 'success', heading: 'Success', message: 'User Updated Successfully' });
        // setShowToaster(true);
        navigate('/franchisee_user/users', {
          state: { message: 'User Updated successfully!' }
        });

      }
      else {
        // Use the generic error handling function
        handleApiError(response, setCurrentUserError);
      }


    });
  }

  // Function to handle individual permission checkbox changes
  const handleRoleChange = (roleId, isChecked) => {
    setSelectedRoles(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        newSelected.add(roleId);
      } else {
        newSelected.delete(roleId);
      }
      console.log("newselected",newSelected);
      return newSelected;
    });
    console.log("selectedRoles",selectedRoles);
    
   
  };




  // Helper function to check if a permission is selected
  const isRoleSelected = (roleId) => selectedRoles.has(roleId);



  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}
          <AppBreadCrumb title={getTitle()}>
            <li>
              <a className="f-s-14 f-w-500" href="#">Masters</a>
            </li>
            <li>
              <a className="f-s-14 f-w-500" href="#">User Masters</a>
            </li>
            <li >
              <a className="f-s-14 f-w-500" href="#">Users</a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a>
            </li>
          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* ready to use form start */}
          <div className="row">
            {/* Book Appointment Form start */}
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>{formType == 'create' ? 'Add New' : 'Edit'} User  {formType == 'edit' ? (':' + currentUser?.name) : ''}</h5>
                </div>
                <div className="card-body">
                  <form className="app-form" >
                    <div className="row">
                    
                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Full Name *</label>
                          <input className="form-control"  placeholder="Enter  Full Name" value={currentUser ? currentUser.name : ''} onChange={(e) => setCurrentUser({ ...currentUser, name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUserError?.name}</span>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Phone Number *</label>
                          <input className="form-control" placeholder="Enter Phone Number" value={currentUser ? currentUser.phone_number : ''} onChange={(e) => setCurrentUser({ ...currentUser, phone_number: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUserError?.phone_number}</span>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Profile Picture </label>
                          <input class="form-control" type="file" onChange={(e)=>setCurrentUser({...currentUser,profile_pic:(e.target.files[0])})}></input>
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUserError?.profile_pic}</span>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Password  {formType == 'create'?'*':''} </label>
                          <input className="form-control" placeholder="Enter Password" value={currentUser ? currentUser.password : ''} onChange={(e) => setCurrentUser({ ...currentUser, password: e.target.value })} required type="password" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUserError?.password}</span>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Confirm Password {formType == 'create'?'*':''} 
                            {currentUser?.password && (
    <span
      className={
        currentUser.password === currentUser.password_confirmation
          ? "text-success ms-1"
          : "text-danger ms-1"
      }
    >
      {currentUser.password === currentUser.password_confirmation
        ? "Password Match"
        : "Password Does not Match"}
    </span>
  )}
                            </label>
                          <input className="form-control" placeholder="Enter Password as above" value={currentUser ? currentUser.password_confirmation : ''} onChange={(e) => setCurrentUser({ ...currentUser, password_confirmation: e.target.value })} required type="password" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentUserError?.password_confirmation}</span>
                        </div>
                      </div>


                      <div className="col-12 floating-select">
                        <div >
                          <label className="form-label">Roles *</label>

                        </div>

                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                          gap: '20px'
                        }}>
                         
                            <div className='mb-2'
                              
                              style={{
                                border: '1px solid #614c4cff',
                                padding: '16px',
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9'
                              }}
                            >
                              {/* Group header with Select All checkbox */}
                             
                              <hr style={{ margin: '0 0 12px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />

                              {/* List of roles  */}
                              <div>
                                {roles.map(role => (
                                  <div key={role.id} style={{ marginBottom: '8px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                      <input
                                        type="checkbox"
                                        value={role.id}
                                        checked={isRoleSelected(role.id)}
                                        onChange={(e) => handleRoleChange(role.id, e.target.checked)}
                                        style={{ marginRight: '8px' }}
                                      />
                                      {replaceHyphenwithSpace(role.name)}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                         
                       </div>

                      </div>



                      <div className="col-12">
                        <div className="text-end">
                          {formType == 'create' ? (
                            <>
                              <button className="btn btn-outline-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveAddUserForm(0)}>Save + Next
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="btn btn-primary me-2 btn-sm btn-md " type="button" onClick={() => saveAddUserForm(1)}>Save + Exit
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M11 12H22M11 12L15 8M11 12L15 16" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="d-none d-md-inline-block btn btn-danger btn-sm btn-md btn-mobile-padding me-2" onClick={handleResetUserForm} type="reset">Reset</button>
                            </>
                          ) : (
                            <>
                              <button className="btn btn-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveEditUserForm(1)}> Update
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              
                            </>
                          )}

                          <button className="d-none  d-md-inline-block btn btn-light-reddit b-r-22 d-inline-flex-center" type="button" onClick={() => navigate('/franchisee_user/users')} >
                          
                            Go Back</button>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Book Appointment Form end */}




          </div>
          {/* ready to use form and */}
        </div>
      </main>

    </>
  )
}

export default UsersForm
